// Modules
import centre from './modules/centre'
import extensions from './modules/extensions'

export default {
    centre,
    extensions
}
